import { useEffect, useState } from "react";
import { PageHeader, useTitle } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { api, asset } from "@/lib/api";
import { useSiteConfig } from "@/context/SiteConfig";
import { STAFF, FACES, IMAGES } from "@/data/content";

const FALLBACK = STAFF.map((s) => ({ ...s, image: FACES[s.face] }));

export default function Staff() {
  useTitle("Staff Team | Aurora Springs RP | RedM Roleplay", "Meet the staff team behind Aurora Springs RP — the admins and moderators of our RedM roleplay community.");
  const { img } = useSiteConfig();
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    api.get("/staff").then(({ data }) => { if (data?.length) setItems(data); }).catch(() => {});
  }, []);

  return (
    <>
      <PageHeader overline="The people behind the sky" title="The Team" image={img("staff", IMAGES.goldRider)}
        sub="Aurora Springs is kept fair, alive and welcoming by a dedicated crew of volunteers who love this world as much as you will." />
      <section className="mx-auto max-w-7xl px-6 sm:px-10 py-20 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((s, i) => (
          <Reveal key={s.id || s.name} delay={i * 0.06}>
            <div data-testid={`staff-card-${i}`} className="group relative overflow-hidden">
              <div className="relative h-[420px] overflow-hidden">
                <img src={asset(s.image)} alt={s.name} className="h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <p className="font-mono text-xs uppercase tracking-widest text-teal">{s.role}</p>
                  <h3 className="mt-2 font-display text-3xl font-light">{s.name}</h3>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </>
  );
}
